import {
  TTranslationAppearanceForm,
} from '@/page/general-settings/appearance/appearance.ts';

const appearanceForm: TTranslationAppearanceForm = {
  locale: {
    label: 'Language',
    tooltip: 'Allows you to select the desired language and locale for the user interface.',
  },
  fontSize: {
    label: 'Page scaling',
    tooltip: 'Allows you to adjust the size of the font and ui element.',
  },
  chartTimeFormat: {
    label: 'Chart time format',
    tooltip: 'Specifies how dates and timestamps are displayed on the X-axis of charts.',
  },
  unitSystem: {
    label: 'Unit system',
    tooltip: 'Choose your preferred measurement units (e.g., metric or imperial) for displaying values.',
  },
  scaleOption: {
    label: 'Layout scaling',
    tooltip: 'Specifies how the scaling of the shop layout should be displayed.',
  },
  showOnlyAvailableApps: {
    label: 'Show only available apps?',
    tooltip: 'Hides apps that are not available to the user.',
  },
};

export default {
  subline: 'Change the way Qmulus looks and feels',
  appearanceForm,
};
